export const STORE_QUERY_KEY = 'store';
export const STORES_QUERY_KEY = 'stores';
export const DOMAIN_CHECK_QUERY_KEY = 'domain-check';
